<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column is-9-widescreen is-9-fullhd">
                <div class="m-b-40">
                    <back-button></back-button>
                    <div class="columns is-flex">
                        <div class="column is-6-mobile">
                            <div class="is-flex is-align-items-start mt-5">
                                <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold mr-5 m-b-20">My Dashboard</h1>
                                <div class="is-hidden-mobile mt-1"><page-help :height="'560px'" :pageHelp="'dashboard'"/></div>
                            </div>
                        </div>
                        <div class="column is-6-mobile is-hidden-tablet is-align-self-center has-text-right">
                            <div class="has-text-centered is-inline-block mt-5">
                                <h4 class="color-grey">Profile status:</h4>
                                <Progress :radius="35" :value="$store.state.auth.userProfile.completedstage2 ? 100: 66" :strokeWidth="10" :strokeColor="$store.state.auth.userProfile.completedstage2?'#1EC48C':'#FFDC4A'" class="is-hidden-mobile">
                                    <div class="content is-size-7 color-blue">{{$store.state.auth.userProfile.completedstage2?'100%':'66%'}}</div>
                                </Progress>
                                <Progress :radius="25" :value="$store.state.auth.userProfile.completedstage2 ? 100: 66" :strokeWidth="5" :strokeColor="$store.state.auth.userProfile.completedstage2?'#1EC48C':'#FFDC4A'" class="is-hidden-tablet">
                                    <div class="content is-size-7 color-blue">{{$store.state.auth.userProfile.completedstage2?'100%':'66%'}}</div>
                                </Progress>
                                <p class="mt-2 mb-3"><a class="is-size-7 text-blue" @click="$router.push('/account')">Update | Edit</a></p>
                            </div>
                        </div>
                        <button id="scrollToAlertBtn" class="is-hidden" v-scroll-to="'#myAlerts'">
                            Scroll to #element
                        </button>
                    </div>
                </div>
                <div class="is-flex dashboard-profile">
                    <div>
                        <h2 class="is-size-7-mobile is-size-4-tablet has-text-weight-bold text-overflow">{{email || this.$store.state.auth.emailUser}}</h2>
                    </div>
                    <div class="is-flex-grow-1 is-flex is-align-items-center is-justify-content-center is-hidden-mobile">
                        <h4 class="color-grey has-text-weight-bold">Profile status:</h4>
                        <Progress :radius="35" :value="$store.state.auth.userProfile.completedstage2 ? 100: 66" :strokeWidth="10" :strokeColor="$store.state.auth.userProfile.completedstage2?'#1EC48C':'#FFDC4A'" class="is-hidden-mobile">
                            <div class="content is-size-7 color-blue">{{$store.state.auth.userProfile.completedstage2?'100%':'66%'}}</div>
                        </Progress>
                        <Progress :radius="25" :value="$store.state.auth.userProfile.completedstage2 ? 100: 66" :strokeWidth="5" :strokeColor="$store.state.auth.userProfile.completedstage2?'#1EC48C':'#FFDC4A'" class="is-hidden-tablet">
                            <div class="content is-size-7 color-blue">{{$store.state.auth.userProfile.completedstage2?'100%':'66%'}}</div>
                        </Progress>
                        <p class="ml-5"><span class="btn btn-clear" @click="$router.push('/account')">Update</span></p>
                    </div>
                 </div>

                <div class="columns is-flex" id="myAlerts">
                    <div class="column is-6 is-align-self-center">
                        
                    </div>
                </div>
                <div class="background-color-white p-5" ref="my-alerts">
                <h2 class="is-size-4 has-text-weight-bold m-b-20 is-hidden-mobile">My Alerts</h2>
                
                <div class="is-flex is-hidden-tablet">
                    <h2 class="is-size-5 has-text-weight-bold is-white-space-nowrap" :class="isShowAlerts ? 'm-b-20':''">My Alerts</h2>
                    <div class="is-justify-content-right is-flex flex-grow" @click="isShowAlerts=!isShowAlerts">
                        <b-icon v-if="isShowAlerts" class="text-blue" size="is-medium" icon="menu-down"></b-icon>
                        <b-icon v-else class="color-grey" size="is-medium" icon="menu-left"></b-icon>
                    </div>
                </div>
                <div v-if="isShowAlerts">

                <div class="columns m-b-20">
                    <span class="column is-4-tablet is-3-fullhd is-align-self-center has-text-weight-bold">Fund alerts recently triggered</span>
                    <div class="column is-2-tablet is-2-fullhd show-hide is-justify-content-flex-start is-hidden-mobile">
                        <a v-if="show1" @click="show1=false" v-tooltip="'Collapse'" class="show"><img class="img-hide" src="/img/show.svg"></a>
                        <a v-else @click="show1=true" v-tooltip="'Expand'" class="hide"><img src="/img/hide.svg"></a>
                    </div>
                </div>
                <div v-if="show1" class="columns is-hidden-mobile">
                    <div class="column is-2 p-b-0">
                        <label class="color-grey has-text-weight-bold">Date</label>
                    </div>
                    <div class="column is-4 p-b-0">
                        <label class="color-grey has-text-weight-bold">Fund</label>
                    </div>
                    <div class="column is-3 p-b-0">
                        <label class="color-grey has-text-weight-bold">Alert</label>
                    </div>
                    <div class="column is-2 p-b-0">
                        <label class="color-grey has-text-weight-bold">Result</label>
                    </div>
                    <div class="column is-1 p-b-0"></div>
                </div>

                <template v-for="(i, index) in recentTrigger">
                    <div v-if="show1" class="columns columns-separate" :key="index">
                        <div @click="isEditAlert=!isEditAlert, selectedFund=i" class="column cursor-pointer is-2 is-flex-mobile">
                            <p class="is-size-7-mobile">{{ i.last_triggered_at | formatDate }}</p>
                            <span v-if="!isAlertPage" @click="removeAlerts(i.option_id, true)" class="is-flex flex-grow is-hidden-tablet is-justify-content-right">
                                <b-icon class="red m-r-10" icon="close" size="is-small"></b-icon>
                            </span>
                        </div>
                        <div @click="isEditAlert=!isEditAlert, selectedFund=i" class="cursor-pointer is-4 column fund-name p-t-0-mobile">
                            <p>{{i.FundBasicsName}}</p>
                        </div>
                        <div @click="isEditAlert=!isEditAlert, selectedFund=i" class="column is-3 cursor-pointer">
                            <p>{{i.type+' '+getAlertOptionSign(i.option)+' '+getAlertThresholdsPrefix(i.type)+i.threshold+i.unit}}</p>
                        </div>
                        <div class="column is-2 p-t-0-mobile p-b-0-mobile">
                            <p @click="isEditAlert=!isEditAlert, selectedFund=i" class="is-size-7-mobile cursor-pointer" v-if="i.result">{{formatResult(i.unit, i.result)}}</p>
                            <span v-else class="not-available">n/a</span>
                        </div>
                        <div class="column is-1 is-hidden-mobile close-cursor-pointer">
                            <span v-if="!isAlertPage" @click="removeAlerts(i.option_id, true)"><b-icon class="red" icon="close" size="is-small"></b-icon></span>
                        </div>
                    </div>
                </template>
                <template v-if="recentTrigger.length==0">
                    <div v-if="show1" class="columns">
                        <div class="column is-2 is-flex-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-4 p-t-0-mobile is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-3 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-2 p-t-0-mobile p-b-0-mobile is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-1 is-hidden-mobile">
                        </div>
                    </div>
                </template>

                <hr v-if="recentTrigger.length==0" class="hr-gray is-hidden-tablet my-2">
                <div class="columns m-b-20 m-t-40">
                    <span class="column is-4-tablet is-3-fullhd is-align-self-center has-text-weight-bold" @click="isEditAlert=!isEditAlert">Fund alerts set up</span>
                    <div class="column is-2-tablet is-2-fullhd show-hide is-justify-content-flex-start is-hidden-mobile">
                        <a v-if="show2" @click="show2=false" v-tooltip="'Collapse'" class="show"><img class="img-hide" src="/img/show.svg"></a>
                        <a v-else @click="show2=true" v-tooltip="'Expand'" class="hide"><img src="/img/hide.svg"></a>
                    </div>
                </div>
                <div v-if="show2" class="columns is-hidden-mobile">
                    <div class="column is-2 p-b-0">
                        <label class="color-grey has-text-weight-bold">Date</label>
                    </div>
                    <div class="column is-4 p-b-0">
                        <label class="color-grey has-text-weight-bold">Fund</label>
                    </div>
                    <div class="column is-5 p-b-0">
                        <label class="color-grey has-text-weight-bold">Alert</label>
                    </div>
                    <!-- <div class="column is-2 p-b-0">
                        <label class="color-grey has-text-weight-bold">Result</label>
                    </div> -->
                    <div class="column is-1 p-b-0"></div>
                </div>
                <template v-for="(i, index) in alertsSetUp">
                    <div :key="index" v-if="show2" class="columns columns-separate">
                        <div @click="selectedFund=i, isEditAlert=!isEditAlert" class="column is-2 is-flex-mobile cursor-pointer">
                            <p class="is-size-7-mobile">{{ i.added_at | formatDate }}</p>
                            <span v-if="!isAlertPage" @click="removeAlerts(i.option_id, false)" class="is-flex is-hidden-tablet flex-grow is-justify-content-right">
                                <b-icon class="red m-r-10" icon="close" size="is-small"></b-icon>
                            </span>
                        </div>
                        <div @click="updateAlert(i)" class="fund-name column is-4 cursor-pointer">
                            <p>{{i.FundBasicsName}}</p>
                        </div>
                        <div @click="updateAlert(i)" class="column is-5 cursor-pointer">
                            <p v-if="i.option">{{i.type+' '+getAlertOptionSign(i.option)+' '+getAlertThresholdsPrefix(i.type)+i.threshold+i.unit}}</p>
                            <p v-else>{{i.type}}</p>
                        </div>
                        <!-- <div class="column is-2">
                            <p @click="selectedFund=i, isEditAlert=!isEditAlert" class="is-size-7-mobile cursor-pointer" v-if="i.option">{{getAlertOptionSign(i.option)+' '+i.threshold+i.unit}}</p>
                            <span v-else class="not-available">n/a</span>
                        </div> -->
                        <div class="column is-1 is-hidden-mobile close-cursor-pointer">
                            <span v-if="!isAlertPage" @click="removeAlerts(i.option_id, false)"><b-icon icon="close" size="is-small" class="red"></b-icon></span>
                        </div>
                    </div>
                </template>
                <template v-if="alertsSetUp.length===0">
                    <div v-if="show2" class="columns">
                        <div class="column is-2 is-flex-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-4 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-5 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <!-- <div class="column is-2 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div> -->
                        <div class="column is-1 is-hidden-mobile">
                        </div>
                    </div>
                </template>

                <div class="columns m-b-20 m-t-40">
                    <span class="column is-4-tablet is-3-fullhd  is-align-self-center is-flex is-align-items-center is-justify-content-space-between">
                        <span class="has-text-weight-bold">
                            New funds alert
                        </span>
                    </span>
                    <div class="column is-8-tablet is-9-fullhd show-hide is-justify-content-flex-start is-align-items-center is-hidden-mobile">
                        <a v-if="show3" @click="show3=false" v-tooltip="'Collapse'" class="show"><img class="img-hide" src="/img/show.svg"></a>
                        <a v-else @click="show3=true" v-tooltip="'Expand'" class="hide"><img src="/img/hide.svg"></a>
                        <div class="m-l-20 email-notification is-flex is-align-items-center is-justify-content-space-around">
                            <span class="font-weight-500 m-r-10 flex-grow">email notification:</span>
                            <label class="is-flex m-t-1 is-flex is-align-items-center">
                                <span>ON</span>
                                <b-field>
                                    <b-switch class="newfund-alert-switch mr-1" v-model="settingNewFunds.isEnableAlertNewFunds" @input="setEnableAlertNewFunds"></b-switch>
                                </b-field>
                                OFF
                            </label>
                        </div>
                    </div>
                </div>
                <!-- New Funds Today -->
                <div v-if="show3">
                  <div class="p-b-10">
                      <p class="is-size-7">New funds added today</p>
                  </div>
                  <div class="overflow-y-auto has-text-centered p-b-20 max-height-400" v-if="alertNewFunds.length > 0">
                    <div class="columns is-mobile">
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <label class="is-size-7 color-grey">ESG?</label>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <label class="is-size-7 color-grey">Mgt Style</label>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <label class="is-size-7 color-grey">Structure</label>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <label class="is-size-7 color-grey">Fund Type</label>
                        </div>
                        <div class="column is-4-desktop is-4-tablet is-6-mobile">
                            <label class="is-size-7 color-grey">Category</label>
                        </div>
                        <div class="column is-4-desktop is-5-tablet is-6-mobile">
                            <label class="is-size-7 color-grey">Fund Name</label>
                        </div>
                        <div class="column is-4-desktop is-5-tablet is-6-mobile">
                            <label class="is-size-7 color-grey">Asset Manager</label>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-5-mobile">
                            <label class="is-size-7 color-grey">Creation Date</label>
                        </div>
                    </div>
                    <template v-for="(i, index) in alertNewFunds">
                      <div :key="index" class="columns is-mobile">
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <p>{{i.is_esg ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <p>{{i.IndexFund ? 'Passive' : 'Active'}}</p>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <p>{{i.LegalStructure}}</p>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-4-mobile">
                            <p>{{i.fund}}</p>
                        </div>
                        <div class="column is-4-desktop is-4-tablet is-6-mobile">
                            <p>{{i.ms_category}}</p>
                        </div>
                        <div class="column is-4-desktop is-5-tablet is-6-mobile">
                            <p>{{i.LegalStructureLegalName}}</p>
                        </div>
                        <div class="column is-4-desktop is-5-tablet is-6-mobile">
                            <p>{{i.CompanyBasicsName}}</p>
                        </div>
                        <div class="column is-2-desktop is-2-tablet is-5-mobile">
                            <p>{{format_date(i.InceptionDate)}}</p>
                        </div>
                      </div>
                    </template>
                  </div>
                  <template v-if="alertNewFunds.length===0">
                    <div class="columns is-hidden-mobile">
                      <div class="column is-2">
                        <label class="is-size-7 color-grey">Category</label>
                      </div>
                      <div class="column is-4">
                          <label class="is-size-7 color-grey">Fund Name</label>
                      </div>
                      <div class="column is-2">
                          <label class="is-size-7 color-grey">Asset Manager</label>
                      </div>
                      <div class="column is-2">
                          <label class="is-size-7 color-grey">Creation Date</label>
                      </div>
                    </div>
                    <div class="columns">
                        <div class="column is-2 is-flex-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-4 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-2 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                        <div class="column is-2 is-hidden-mobile">
                            <span class="not-available"></span>
                        </div>
                    </div>
                  </template>
                  <!-- Filter Criteria -->
                  <div class="m-t-10 columns">
                      <p class="is-size-7 column is-4-tablet is-3-fullhd is-align-self-center is-hidden-mobile">Filter new funds by</p>
                      <div class="column is-2-tablet is-2-fullhd show-hide is-justify-content-flex-start is-hidden-mobile">
                        <a v-if="show4" @click="show4=false" v-tooltip="'Collapse'" class="show"><img class="img-hide" src="/img/show.svg"></a>
                        <a v-else @click="show4=true" v-tooltip="'Expand'" class="hide"><img src="/img/hide.svg"></a>
                      </div>
                  </div>
                  <div class="p-t-10 is-flex is-hidden-tablet">
                      <p class="is-size-7 is-white-space-nowrap">Filter new funds by</p>
                      <div class="is-justify-content-right is-flex flex-grow" @click="show4=!show4">
                          <b-icon v-if="show4" class="text-blue" size="is-medium" icon="menu-down"></b-icon>
                          <b-icon v-else class="color-grey" size="is-medium" icon="menu-left"></b-icon>
                      </div>
                  </div>
                  <div class="columns is-size-7" v-if="show4">
                    <div class="column is-3" v-if="fundType">
                        <p>Fund Type</p>
                        <b-checkbox class="p-t-10" :value="settingNewFunds.fundTypeGroup.length === Object.values(fundType).length" @input="addAllFundType($event)">All</b-checkbox>
                        <div v-for="key in Object.keys(fundType)" :key="key" class="is-flex is-2-mobile">
                          <b-checkbox class="p-t-10" :class="{ 'has-text-weight-bold': isBondType(fundType[key])}" v-model="settingNewFunds.fundTypeGroup" :native-value="fundType[key]">{{fundType[key]}}</b-checkbox>
                        </div>
                    </div>
                    <div class="column is-3">
                        <p>MGT Style</p>
                        <div class="is-flex is-flex-direction-column is-2-mobile">
                          <b-radio class="p-t-10" native-value="All" name="MGT" v-model="settingNewFunds.indexFund">All</b-radio>
                          <b-radio class="p-t-10" :native-value="false" name="MGT" v-model="settingNewFunds.indexFund">Active</b-radio>
                          <b-radio class="p-t-10" :native-value="true" name="MGT" v-model="settingNewFunds.indexFund">Passive</b-radio>  
                        </div>              
                    </div>
                    <div class="column is-3">
                        <p>Structure</p>
                        <div class="is-flex is-flex-direction-column is-2-mobile">
                          <b-checkbox class="p-t-10" native-value="etf" v-model="settingNewFunds.structureGroup">ETF</b-checkbox>
                          <b-checkbox class="p-t-10" native-value="it" v-model="settingNewFunds.structureGroup">IT</b-checkbox>
                          <b-checkbox class="p-t-10" native-value="mutual_funds" v-model="settingNewFunds.structureGroup">Mutual Funds</b-checkbox>  
                        </div>  
                    </div>
                    <div class="column is-3">
                        <p>ESG Funds Only</p>
                        <b-checkbox class="p-t-10" v-model="settingNewFunds.isEsg"></b-checkbox>
                    </div>
                  </div>
                  <div class="has-text-right" v-if="show4">
                    <button class="button is-uppercase is-size-7 is-primary" @click="submitNewFundsFilters()">Apply</button>
                  </div>
                </div>

                </div>
                </div>

                <div class="columns p-3">
                    <div class="column is-4-tablet background-color-white m-t-20 p-5 min-height-300" style="height: fit-content;">
                        <h2 class="is-size-4 has-text-weight-bold m-b-40 is-hidden-mobile">Recent searches</h2>
                        <div class="is-flex is-hidden-tablet">
                            <h2 class="is-size-5 has-text-weight-bold is-white-space-nowrap" :class="isShowRecent ? 'm-b-20':''">Recent searches</h2>
                            <div class="is-justify-content-right is-flex flex-grow" @click="isShowRecent=!isShowRecent">
                                <b-icon v-if="isShowRecent" class="text-blue" size="is-medium" icon="menu-down"></b-icon>
                                <b-icon v-else class="color-grey" size="is-medium" icon="menu-left"></b-icon>
                            </div>
                        </div>
                        <template v-if="isShowRecent">
                            <div v-if="recentSearches">
                                <div v-for="(i, index) in recentSearches" :key="index">
                                    <span class="is-size-7 uppercase-first-character">{{i.type}}</span>
                                    <p class="is-size-7 p-1" @click="searchType(i.text, i.code, i.type)"><a>{{i.text ? i.text : 'All'}} ({{i.total}})</a></p>
                                </div>
                            </div>
                            <div v-else>
                                <span class="not-available"></span>
                            </div>
                        </template>
                    </div>
                    <div class="column is-8-tablet dashboard-watchlists background-color-white m-t-20 p-5 overflow-hidden min-height-300">
                        <div class="m-b-30 is-hidden-mobile px-2 is-flex">
                            <h2 class="is-size-4 has-text-weight-bold ">My Watchlists</h2>
                            <div class="text-align-center m-l-20">
                                <b-button type="is-primary" class="is-uppercase is-size-7" @click="createWatchClick">Create new</b-button>
                            </div>
                        </div>
                        <div class="is-flex is-hidden-tablet">
                            <h2 class="is-size-5 has-text-weight-bold is-white-space-nowrap" :class="isShowWatchlists ? 'm-b-20':''">My Watchlists</h2>
                            <div class="is-justify-content-right is-flex flex-grow" @click="isShowWatchlists=!isShowWatchlists">
                                <b-icon v-if="isShowWatchlists" class="text-blue" size="is-medium" icon="menu-down"></b-icon>
                                <b-icon v-else class="color-grey" size="is-medium" icon="menu-left"></b-icon>
                            </div>
                        </div>

                        <div v-if="isShowWatchlists">
                            <div class="text-align-center m-t-20-mobile is-hidden-tablet" :class="myWatchlists.length===0?'m-t-90-tablet':''">
                                <b-button type="is-primary" class="is-uppercase is-size-7" @click="createWatchClick">Create new</b-button>
                            </div>

                            <div v-if="myWatchlists && myWatchlists.length" class="watch-lists pt-4">
                                <template v-for="(item, index) in myWatchlists">
                                    <div :key="index" class="watch-lists-item">
                                        <div class="p-2">
                                            <div class="p-4 box-my-watchlist close-cursor-pointer" :class="`background-watchlist-${index}`">
                                                <span @click="removeWatchlist(item)"><b-icon icon="close" size="is-small" class="white-text btn-close is-hidden-mobile"></b-icon></span>
                                                <span class="is-block is-relative" @click="removeWatchlist(item)"><b-icon icon="close" size="is-small" class="white-text btn-close btn-close-mobile is-hidden-tablet"></b-icon></span>
                                                <div @click="navigateToWatchlist(item)" class="text-box is-uppercase has-text-weight-bold white-text is-size-7 cursor-pointer"><span class="cursor-pointer">{{item.name}}</span></div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column p-3">
                        <recently-history :type="'viewed'" :title="'Funds recently viewed'" :recentFunds="recentViewed"></recently-history>
                    </div>
                    <div class="column p-3">
                        <recently-history :type="'compared'" :title="'Funds recently Compared'" :recentFunds="recentCompared"></recently-history>
                    </div>
                    <div class="column p-3">
                        <recently-history :type="'referrals'" :title="'Recent platform checks'" :recentFunds="recentReferrals"></recently-history>
                    </div>
                </div>
                <div class="columns">
                    <div class="column disclaimer">
                        <Disclaimer />
                    </div>
                </div>
            </div>
            <div ref="subRight_before" class="column is-12-mobile is-3-widescreen banner-right is-3-fullhd">
                <div class="banner-on-top" ref="subRight">
                    <AdsGoogle />
                </div>
            </div>
        </div>
        <b-modal has-modal-card 
            :full-screen="isMobile()?true:false" 
            can-cancel="outside" 
            v-model="isModalCreatedWatchlist" 
            :width="640">
            <watchlist-modal></watchlist-modal>
        </b-modal>
        <buttons 
        :editAlert="isEditAlert"
        :fund_data="selectedFund"
        ></buttons>
    </div>
</template>



<script>
import RecentlyHistory from "@/components/RecentlyHistory";
import Progress from "easy-circular-progress";
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import WatchlistModal from '@/components/WatchlistModal.vue';
import compositeMixin from "@/mixins/compositeMixin";
import Buttons from '@/components/Buttons.vue';
import axios from 'axios';
import { mapState } from 'vuex';
import moment from 'moment';
import BackButton from '@/components/BackButton.vue';
import Disclaimer from "@/components/Disclaimer";
import PageHelp from '@/components/PageHelp.vue';
import AdsGoogle from '@/components/AdsGoogle.vue';

export default {
    name: 'Dashboard',
    components: { RecentlyHistory, Progress, WatchlistModal, Buttons, BackButton, Disclaimer, PageHelp, AdsGoogle },
    mixins: [commonMixin, compositeMixin, bannerMixin],
    data(){
        return{
            show1: true,
            show2: true,
            show3: true,
            show4: false,
            isShowAlerts: true,
            isShowRecent: true,
            isAlertPage: false,
            isShowWatchlists: true,
            isModalCreatedWatchlist: false,
            isEditAlert: false,
            searchObject:{
                "type":null,
                "text":"",
                "code":null
            },
            recentSearches: [],
            recentViewed: [],
            recentCompared: [],
            recentReferrals: [],

            recentTrigger: [],
            alertsSetUp: [],
            selectedFund: {},
            email: this.$store.state.auth.emailUser,
            settingNewFunds: {
              fundTypeGroup: [],
              indexFund: 'All',
              structureGroup: ['etf', 'it', 'mutual_funds'],
              isEsg: false,
              isEnableAlertNewFunds: false
            },
            alertNewFunds: []
        }
    },
    watch: {
        '$store.state.auth.authenticated': function (data) {
            if(!data) this.$router.push('/login/max-5')
        },
        'currentRouteName': function (data) {
            if (data == 'Alert') {
               this.scrollToAlert()
               this.isAlertPage = true
            }
            else {
                this.isAlertPage = false
            }
        },
        'fundType': {
          handler(value) {
            if (value) {
              this.fetchNewFunds()
            }
          }
        }
    },
    computed: {
        ...mapState('watchlist', {
            myWatchlists: 'myWatchlists',
        }),
         currentRouteName() {
            return this.$route.name;
        },
        fundType () {
          return this.$store.state.search.homeCategoryList.fund
        }
    },
    
    filters: {
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY");
        }
    },
    methods: {
        getAlertOptionSign(option) {
            let result = option;
            switch(option) {
                case "Greater Than": {
                    result = '>'
                    break;
                }
                case "Less Than": {
                    result = '<'
                    break;
                }
                default:
                break
            }

            return result
        },
        getAlertThresholdsPrefix(type) {
            let result = "";

            switch (type) {
                case "Net Assets":
                    result = "£"
                    break;
                default:
                    break;
            }   

            return result
        },
        updateAlert(item) {
            this.selectedFund = item
            this.isEditAlert = true
        },
        goto(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop;

            window.scrollTo(0, top);
        },
        scrollToAlert() {
            const scrollToAlertBtn = document.getElementById('scrollToAlertBtn');
            scrollToAlertBtn.click()
        },
        createWatchClick() {
            if (this.myWatchlists.length < 5) {
                this.isModalCreatedWatchlist = !this.isModalCreatedWatchlist
            } else {
                this.$toast.error('You can only create 5 Watchlists!')
            }
        },
        removeWatchlist(watchlist) {
            this.$buefy.dialog.confirm({
                type: 'is-danger',
                hasIcon: true,
                message: 'Delete Watchlist?',
                onConfirm: async () => {
                    await axios.delete(`/watchlist/${watchlist.id}`)
                    this.$store.dispatch("watchlist/getMyWatchlists")
                }
            })
        },
        removeAlerts(optionId, isRecent) {
            this.$buefy.dialog.confirm({
                type: 'is-danger',
                hasIcon: true,
                message: 'Delete alert?',
                onConfirm: async () => {
                    await axios.delete(`/alerts/option`, {
                        params: {
                            option_id: optionId
                        }
                    });
                    this.getMyAlert(isRecent)
                }
            })
        },
        navigateToWatchlist(watchlist) {
            this.$store.commit("watchlist/SET_CURRENT_WATCHLIST", watchlist);
            this.$store.commit("watchlist/SET_SORTING1", {});
            this.$store.commit("watchlist/SET_SORTING2", {});
            this.$router.push({name:"Watchlist"});
        },
        searchType(text, code, typeSearch) {
            this.searchObject={
                "type":typeSearch,
                "text":text?text:'',
                "code": code,
                "source": 4
            }
            if(typeSearch==='category') this.$store.commit("search/SET_ACTIVECATEGORIES",code)
            this.search(this.searchObject);
        },
        async search(obj){
            await this.$store.dispatch("search/apiCall",obj)
            this.$store.commit("search/SET_ABSOLUTETOTAL", this.$store.state.search.searchData.total)
            if(obj.type != "category"){
                const { ...lastSearch } = obj;
                this.$store.commit("search/ADD_SEARCHBAR_HISTORY", lastSearch)
            }
            let textURL = '';
            if(obj.text) textURL = this.convertURL(obj.text.replaceAll('/', '*'))
            window.scrollTo(0, 0)
            await this.$router.push({name:"Results", params: {id: this.$store.state.search.searchData.searchdata_id, text: textURL!==''?textURL:'All'}})
        },
        getRecentSearches() {
            axios.post("/stats/recent-searches", {
                native: this.$store.state.search.currency,
            }).then(res => {
                this.recentSearches = res.data.data;
            })
        },
        getRecentViewed() {
            axios.post("/stats/recent-viewed", {
                native: this.$store.state.search.currency,
            }).then(res => {
                this.recentViewed = res.data.data;
                this.$store.commit("fund/SET_FUNDS_RECENTLY_VIEWED", res.data.data);
            })
        },
        getRecentCompared() {
            axios.post("/stats/recent-compared", {
                native: this.$store.state.search.currency,
            }).then(res => {
                this.recentCompared = res.data.data;
                this.$store.commit("fund/SET_FUNDS_RECENTLY_COMPARED", res.data.data);
            })
        },
        getRecentReferrals() {
            axios.post("/stats/recent-referrals", {
                native: this.$store.state.search.currency,
            }).then(res => {
                this.recentReferrals = res.data.data;
                this.$store.commit("fund/SET_FUNDS_RECENTLY_REFERRAL", res.data.data);
            })
        },
        getMyAlert(isRecent) {
            axios.get(`/alerts?recent=${isRecent}`).then(res => {
                if(isRecent) this.recentTrigger = res.data.data;
                else this.alertsSetUp = res.data.data;
            })
        },
        addAllFundType(e) {
          this.settingNewFunds.fundTypeGroup = e ? Object.values(this.fundType) : []
        },
        getNewFundsSetting() {
            axios.get("/setting-new-funds").then(res => {
              if (res.data) {
                const data = res.data.data
                this.settingNewFunds = {
                  fundTypeGroup: data.filters.categories,
                  indexFund: data.filters.mgt_style === 'active' ? false : data.filters.mgt_style === 'passive' ? true : 'All' ,
                  structureGroup: data.filters.structure,
                  isEsg: data.filters.esg === 'active',
                  isEnableAlertNewFunds: data.enable_alert_new_funds
                }
              }
            })
        },
        setEnableAlertNewFunds() {
          axios.post("/setting-new-funds",
          {enable_alert_new_funds: this.settingNewFunds.isEnableAlertNewFunds}).catch(err => {
            this.$toast.error(err.response.data.message)
            this.settingNewFunds.isEnableAlertNewFunds = !this.settingNewFunds.isEnableAlertNewFunds
          })
        },
        fetchNewFunds() {
          axios.get("/new-funds",
          { params: { 
            categories: this.settingNewFunds.fundTypeGroup,
            mgt_style: this.settingNewFunds.indexFund === 'All' ? 'All' : this.settingNewFunds.indexFund ? 'passive' : 'active',
            structure: this.settingNewFunds.structureGroup,
            esg: this.settingNewFunds.isEsg ? 'active' : 'passive'}
          }).then(res => {
            if (res.data) {
              this.alertNewFunds = res.data.data.data
            }
          }).catch(err => {
            this.$toast.error(err.response.data.message)
          })
        },
        submitNewFundsFilters() {
          this.fetchNewFunds()
        },
        format_date(value){
          if (value) {
              return moment(String(value)).format('DD-MMM-YY')
          }
          else{
              return "<span style='#ccc'>n/a</span>"
          }
        },
        isBondType(type) {
          const typeBonds = ['Bonds', 'Equity', 'Infrastructure', 'Private Equity', 'Real Estate']
          return typeBonds.includes(type)
        },
        formatResult(unit, result) {
            if (unit === 'm') {
                return this.currency("GBP", this.parseNA(result)) + 'M';
            } else if (unit === '%') {
                return parseFloat(result).toFixed(2) + '%';
            }
            return result;
        }
    },

    created() {
        this.$store.dispatch("watchlist/getMyWatchlists")
        this.getMyAlert(true);
        this.getMyAlert(false);
        this.getRecentSearches();
        this.getRecentViewed();
        this.getRecentCompared();
        this.getRecentReferrals();
        this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'dashboard_page');
        this.getNewFundsSetting()
    },
    async mounted() {
        window.addEventListener('scroll', this.handleScroll);
        if (this.$route.name == 'Alert') {
            this.scrollToAlert()
            this.isAlertPage = true
        }
        this.$bus.$on('newAlertAdded', val => {
            if (val) {
                this.getMyAlert(true);
                this.getMyAlert(false);
            }
            
        })
        this.$bus.$on('closeAlertModal', val =>{
            this.isEditAlert = val
        })
        if(this.$store.state.auth.authenticated && !this.email) {
            axios.get("/api/profile").then(response => {
                const profile = response.data
                this.email = profile.email
                this.$store.commit("auth/SET_EMAIL", profile.email)
            })
        }
        await this.$store.dispatch("search/getCategoriesSearch",{})
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    metaInfo() {
        return {
            title: "My Dashboard | Pickafund",
            meta: [
                { name: 'description', content:  'Your Pickafund account details all in one place.'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
        }
    },
}

</script>

<style scoped lang="scss">
    .newfund-alert-switch {
        transform: rotate(180deg);
    }

    .fund-name {
        p {
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;

        }
    }
    .dashboard-profile {
        display: flex;
        align-items: center;
        margin-top: -60px;
    }

    .btn-close-mobile {
        right: 10px;
        top: 0
    }

    .columns-separate {
        border-bottom: 1px solid #bfbfbf;
    }
    
</style>